<template>
  <div class="photo component">
    <ModalPhotoView
      closeOnOverlay
      :photoId="+photoId"
      :show="isShownModalPhoto"
      @close="onCloseModal">
    </ModalPhotoView>
  </div>
</template>

<script>
  import ModalPhotoView from './PhotoModal.vue'
  export default {
    name: 'Photo',
    props: ['albumId', 'photoId'],
    components: {
      ModalPhotoView
    },
    data () {
      return {
        isShownModalPhoto: true
      }
    },
    methods: {
      onCloseModal () {
        this.$router.push({name: 'album-view', params: {albumId: this.albumId}})
      }
    }
  }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/album/Photo.vue